import loadable from '@loadable/component';
import type { Portfolio } from '@/hooks/portfolio/usePortfolio';
import { usePortfolio } from '@/hooks/portfolio/usePortfolio';

import { LoadingState } from './LoadingState';
const ErrorState = loadable(() => import('./ErrorState'), {
  resolveComponent: (c) => c.ErrorState,
  fallback: <LoadingState />,
});
const PopulatedState = loadable(() => import('./PopulatedState'), {
  resolveComponent: (c) => c.PopulatedState,
  fallback: <LoadingState />,
});
const EmptyState = loadable(() => import('./EmptyState'), {
  resolveComponent: (c) => c.EmptyState,
  fallback: <LoadingState />,
});

const RestrictedState = loadable(() => import('./RestrictedState'), {
  resolveComponent: (c) => c.RestrictedState,
  fallback: <LoadingState />,
});

type Props = {
  portfolioId: Portfolio['id'];
};

export const PortfolioCard = ({ portfolioId }: Props) => {
  const { data: portfolio, status } = usePortfolio({
    id: portfolioId,
  });

  if (status === 'pending') {
    return <LoadingState />;
  }

  if (status === 'error') {
    return <ErrorState />;
  }

  if (portfolio?.isAnalysisRestricted) {
    return <RestrictedState portfolio={portfolio} />;
  }

  if (!portfolio || portfolio.holdings.length === 0) {
    return (
      <EmptyState portfolioName={portfolio?.name} portfolioId={portfolioId} />
    );
  }

  return <PopulatedState portfolio={portfolio} />;
};
